import { Navbar } from '../../components/feature/Navbar';
import { PageHero } from '../../components/feature/PageHero';
import { TrustBar } from '../../components/feature/TrustBar';
import { LocationDetail } from './components/LocationDetail';
import { AIAnswerBlock } from '../../components/feature/AIAnswerBlock';
import { MidCTABanner } from '../../components/feature/MidCTABanner';
import { Process } from '../home/components/Process';
import { WhyChooseUs } from '../home/components/WhyChooseUs';
import { ServiceAreas } from '../../components/feature/ServiceAreas';
import { Testimonials } from '../home/components/Testimonials';
import { FAQ } from '../../components/feature/FAQ';
import { QuoteForm } from '../home/components/QuoteForm';
import { Footer } from '../../components/feature/Footer';

export default function LocationsPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <PageHero
        title="Find Signarama"
        titleHighlight="Arlington, TX"
        subtitle="Conveniently located in Arlington, Texas — serving businesses throughout Grand Prairie, Fort Worth, Mansfield, Irving, and all of the DFW Metroplex."
        backgroundImage="https://cdn.gorilladash.com/images/media/8024538/signarama-usa-dimensional-lettering-48743844537-o-banner-6740b6f63000f.jpg?format=pjpg&auto=webp&quality=90&width=1920"
        primaryCTA="Get Directions"
        primaryCTAAction={() => {
          window.open(
            'https://www.google.com/maps/search/?api=1&query=32.708617,-97.147128&query_place_id=ChIJkRKWLsV8ToYRhAcULCMpvSc',
            '_blank'
          );
        }}
        secondaryCTA="Request a Quote"
        secondaryCTAHref="#get-quote"
        badge="2400 W Pioneer Pkwy #118 · Arlington, TX 76013"
      />
      <TrustBar />
      <LocationDetail />
      <AIAnswerBlock context="locations" />
      <MidCTABanner />
      <Process />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQ context="locations" />
      <QuoteForm />
      <Footer />
    </div>
  );
}
